import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import axios, { isAxiosError } from "axios"
import Loadingwrapper from "../../component/LoadingWrapper"
import { useSelector } from "react-redux"
import Pagination from "../../component/Pagination"
import HotPairImages from "./HotPairImages"

const HotpairFeed = ({ }) => {
  const [searchParams, setSearchParams] = useSearchParams({ gender: "F", type: "", page: 1, limit: 20, geography: 'all' })
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)
  const [trends, setTrends] = useState([])
  const [silhouetteCounts, setSilhouetteCounts] = useState([])
  const [colorCounts, setColorCounts] = useState([])
  const [selectedTrendPopup, setSelectedTrendPopup] = useState(null)
  const userLoggedIn = useSelector(state => state.userLoggedIn)


  async function getTrends(signal) {

    try {
      const response = await axios.get(`/api/hot-pairs`, { params: searchParams, signal })
      if (response.data && response.data.trends) {
        setTrends(response.data.trends)
        setCount(response.data.count)
        setLoading(false)

      }
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }

  }

  async function getTrendCounts(signal) {

    try {
      const response = await axios.get(`/api/hot-pairs/counts`, { params: searchParams, signal })
      if (response.data) {
        setColorCounts(response.data.colorCounts)
        setSilhouetteCounts(response.data.silhouetteCounts)
      }
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }

  }

  useEffect(() => {
    setLoading(true)
    const aborter = new AbortController()
    getTrends(aborter.signal)
    return () => { aborter.abort() }


  }, [searchParams])
  function handlePageChange(value) {
    setSearchParams(prev => {
      prev.set('page', value)
      return prev
    })
  }

  useEffect(() => {
    setLoading(true)
    const aborter = new AbortController()
    getTrendCounts(aborter.signal)
    return () => { aborter.abort() }
  }, [searchParams.get('geography'), searchParams.get('gender')])

  function unselectTrend() {
    setSelectedTrendPopup(null)
  }

  return <div>
    <h2 className="text-center font-semibold text-2xl lg:text-[32px] p-0.5 lg:p-2">Hot Pairs</h2>
    <div className="sticky top-11 lg:top-10 z-10 bg-white" >
      <div className="w-screen flex justify-between flex-wrap">

        <div className="w-screen shrink-0 lg:shrink-1   flex lg:p-2 lg:px-2 flex-wrap justify-center lg:justify-start">
          <select className="p-1 rounded border mx-2 my-1"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('gender', e.target.value)
                prev.set('page', '1')
                return prev
              })
            }}
            value={searchParams.get('gender') || 'F'}
          >
            <option disabled value={'select'}>--select gender--</option>
            <option value={'F'}>Women</option>
            <option value={'M'}>Men</option>
          </select>
          <select className="p-1 rounded border mx-2 my-1"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('geography', e.target.value)
                prev.set('page', '1')
                return prev
              })
            }}
            value={searchParams.get('geography') || 'all'}
          >
            <option disabled value={'select'}>--select geography--</option>
            <option value={'all'}>All Geography</option>
            <option value={'indian'}>Indian</option>
            <option value={'asian,western'}>Asian+Western</option>
          </select>
          <select className="p-1 rounded border mx-2 my-1"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('type', e.target.value)
                prev.set('page', '1')
                return prev
              })
            }}
            value={searchParams.get('type') || 'all'}
          >
            <option disabled value={'select'}>--select type--</option>
            <option value={'all'}>All hot pairs</option>
            <option value={'silhouette'}>Best Topwear and Bottomwear Silhouette combinations</option>
            <option value={'color'}>Best Color combination</option>
            <option value={'dress_color'}>Best Dress and Accessories Color combination</option>
          </select>
          <select className="p-1 rounded border mx-2 my-1"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('silhouette', e.target.value)
                prev.set('page', '1')
                return prev
              })
            }}
            value={searchParams.get('silhouette') || 'all'}
          >
            <option disabled value={'select'}>--select type--</option>
            <option value={'all'}>All Silhouette</option>
            {silhouetteCounts.map(c => <option value={c.name}>{c.name}({c.count})</option>)}
          </select>
          <select className="p-1 rounded border mx-2 my-1"
            onChange={e => {
              setSearchParams(prev => {
                prev.set('color', e.target.value)
                prev.set('page', '1')
                return prev
              })
            }}
            value={searchParams.get('color') || 'all'}
          >
            <option disabled value={'select'}>--select type--</option>
            <option value={'all'}>All Colors</option>
            {colorCounts.map(c => <option value={c.name}>{c.name}({c.count})</option>)}
          </select>
        </div>
      </div>

      <div className="justify-end flex w-screen">
        <Pagination
          count={Math.ceil(count / parseInt(searchParams.get('limit') || 20))}
          page={parseInt(searchParams.get('page') || 1)}
          onChange={handlePageChange}
        />
      </div>

    </div>


    <Loadingwrapper loading={loading} className="mb-4 lg:mb-40" >
      {trends.map((trend, index) => <div className="relative w-screen py-1">
        <div className="w-full pl-4 font-semibold text-lg text-blue-500 hover:text-blue-600 "
          onClick={() => {
            setSelectedTrendPopup(trend)
          }}
        >{((parseInt(searchParams.get('page') || '1') - 1) * (searchParams.get('limit') || '20')) + index + 1}. {trend.set1Value} {trend.set1Category} &times; {trend.set2Value} {trend.set2Category} - {trend.count}</div>
        <div className="flex w-full overflow-x-auto">
          {trend.images.map(im => <div className="h-60 px-1 w-auto shrink-0"><img src={im.imageUrl} className='h-full' /></div>)}
        </div>
      </div>)}

    </Loadingwrapper>
    {selectedTrendPopup ? <HotPairImages show={selectedTrendPopup != null} hidePopup={unselectTrend} searchParams={searchParams} trend={selectedTrendPopup} /> : null}

  </div>
}

export default HotpairFeed
